module.exports = {
  email: 'lakhalbadr2@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/BALK-03',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/badr-lakhal-721603276/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Recommendations',
      url: '/#recommendations',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
    {
      name: 'Blogs',
      url: '/pensieve',
    },
  ],

  colors: {
    green: '#79bac1',
    navy: '#0f1115',
    darkNavy: '#0a0c0f',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
